import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value !== undefined && _vm.value !== null)?_c(VProgressLinear,{staticClass:"table-value-progress",attrs:{"color":_vm.color,"background-opacity":"0","height":"30px","value":_vm.max > 0 ? Math.max(5, (_vm.value / _vm.max) * 100) : 0}},[_vm._t("default")],2):_c('div',{staticClass:"grey--text caption"},[_vm._v(" N/A ")])}
var staticRenderFns = []

export { render, staticRenderFns }